import { useData } from "vike-react/useData";
import ProductCard from "@/components/shop/ProductCard";
import ShopCartPill from "@/components/shop/ShopCartPill";
import TomorrowCollection from "@/components/tomorrow/TomorrowCollection";
import { TOMORROW_SLUG } from "@/data/tomorrow-co";
import theme from "@/styles/store-theme.module.css";
import type { CollectionData } from "./+data";
import styles from "./collection.module.css";

/** Cards in the first row at desktop widths: their photos are above the fold. */
const FIRST_ROW = 4;

export default function CollectionPage() {
  const { collection, products } = useData<CollectionData>();
  if (collection.slug === TOMORROW_SLUG) return <TomorrowCollection collection={collection} products={products} />;
  return <GenericCollection collection={collection} products={products} />;
}

/** A collection's own page in the store's concept style (every collection but Tomorrow Co). */
function GenericCollection({ collection, products }: Pick<CollectionData, "collection" | "products">) {
  return (
    <main className={`${theme.store} ${styles.page}`}>
      <section className={styles.hero}>
        <span className={styles.eyebrow}>OddStack Apparel</span>
        <h1 className={styles.title}>
          {collection.name}
          <span className={theme.dot}>.</span>
        </h1>
        {collection.description && <p className={styles.sub}>{collection.description}</p>}
      </section>

      <section aria-label={`${collection.name} products`} className={styles.section}>
        {products.length > 0 ? (
          <div className={styles.grid}>
            {products.map((p, i) => (
              <ProductCard key={p.id} product={p} collectionName={collection.name} eager={i < FIRST_ROW} highPriority={i === 0} />
            ))}
          </div>
        ) : (
          <p className={styles.empty}>The first pieces are on their way.</p>
        )}
      </section>

      <div className={styles.back}>
        <a href="/shop#collections" className={theme.btnOutline}>
          ← ALL COLLECTIONS
        </a>
      </div>

      <ShopCartPill />
    </main>
  );
}
